import React, { useContext } from 'react';

import TabPanel from '../TabPanel';
import { type SettingsModalTabProps } from '../types';

import CompanyContractTypesSection from './CompanyContractTypesSection';
import CompanyHolidaysSection from './CompanyHolidaysSection';
import EditCompanyDetails from './EditCompanyDetails';
import GlobalSettingsSection from './GlobalSettingsSection';
import KickOffTemplatesSection from './KickOffTemplateSection';
import ProjectTemplatesSection from './ProjectTemplateSection';
import SubscriptionSection from './SubscriptionSection';
import WorkShiftsSection from './WorkShiftsSection';

import OverwatchAccordion from '@/components/OverwatchAccordion';
import CurrentUserContext from '@/Contexts/CurrentUser';
import PermissionContext from '@/Contexts/Permissions';
import { PermissionActionEnum, PermissionEntityEnum } from '@/graphql/generated/graphql';

const CompanySettingsTab: React.FC<SettingsModalTabProps> = ({ parentTab, index, showHeading }) => {
  const { currentUser } = useContext(CurrentUserContext);
  const { canPerformAction } = useContext(PermissionContext);
  const { View } = PermissionActionEnum;
  const { Projects, ProjectKickOff } = PermissionEntityEnum;

  if (!currentUser) return <></>;

  return (
    <TabPanel value={parentTab} index={index} heading="Company Settings" showHeading={showHeading}>
      <EditCompanyDetails />
      {currentUser.isOwner && (
        <OverwatchAccordion title="Subscription">
          <SubscriptionSection />
        </OverwatchAccordion>
      )}
      <OverwatchAccordion title="Global Settings">
        <GlobalSettingsSection />
      </OverwatchAccordion>
      {currentUser.isOwner && (
        <OverwatchAccordion title="Work Shifts" height="300px">
          <WorkShiftsSection />
        </OverwatchAccordion>
      )}
      {currentUser.isOwner && (
        <OverwatchAccordion title="Company Holidays" height="350px">
          <CompanyHolidaysSection />
        </OverwatchAccordion>
      )}
      {canPerformAction(View, Projects) && (
        <OverwatchAccordion title="Project Templates Management">
          <ProjectTemplatesSection />
        </OverwatchAccordion>
      )}
      <OverwatchAccordion title="Company Supported Contracts" height="300px">
        <CompanyContractTypesSection />
      </OverwatchAccordion>
      {canPerformAction(View, ProjectKickOff) && (
        <OverwatchAccordion title="Kick-Off Template Management" height="300px">
          <KickOffTemplatesSection />
        </OverwatchAccordion>
      )}
    </TabPanel>
  );
};

export default CompanySettingsTab;
